module.exports = __webpack_public_path__ + "static/2-64917c8ab7b009dcb2dc3995767ac69a.png";